enum MailListContextMenuSource {
    MailListItem,
    MailListItemPart,
}

export default MailListContextMenuSource;
